module.exports = __webpack_public_path__ + "img/roll9.680aaedc.png";